import React, { useState, useRef, useEffect } from "react";
import { ReCaptcha } from "react-recaptcha-google";
import PrimaryButton from "../../elements/primary-button";
import Input from "../../elements/input";
import { FilterDropdown, Dropdown } from "../../elements";
import BodyText from "../../elements/body-text";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import Checkbox from "../../elements/checkbox";
import getSiteInfo from "../../utils/getSiteInfo";
import { emailFormat } from "../../utils/email";
import InputPhoneNumber from "../../elements/InputPhoneNumber";
import api from "../../utils/api";
import "./style.scss";

const TestDriveForm = ({ heading, name, appellation, phoneCode, phone, email, country, dealer, city, checkbox, subscribecheckbox, hasCaptcha, captchaSiteKey = "6LfjOcYUAAAAANME_u_2e6qqtmbY0W5csletwBMG", hasError, errorMessage, button, disclaimer, onSubmitForm = () => {} }) => {
  const [captchaValidated, setCaptchaValidated] = useState(!hasCaptcha);
  const [nameEntered, setNameEntered] = useState(name.value);
  const [nameError, setNameError] = useState(null);
	const phoneCodeNode = useRef();
  const [appellationSelected, setAppellationSelected] = useState(appellation.selection);
  const [appellationError, setAppellationError] = useState(null);
  const [phoneCodeSelected, setPhoneCodeSelected] = useState(phoneCode.code);
  const [phoneCodeError, setPhoneCodeError] = useState();
  const [phoneEntered, setPhoneEntered] = useState(phone.value);
  const [phoneIsValid, setPhoneIsValid] = useState(true);
  const [phoneError, setPhoneError] = useState(null);
  const [emailEntered, setEmailEntered] = useState(email.value);
  const [emailEnteredIsValid, setEmailEnteredIsValid] = useState(true);
  const [emailError, setEmailError] = useState(null);
  const [countryError, setCountryError] = useState();
  const [cityError, setCityError] = useState();
  const [dealerError, setDealerError] = useState();
  const [termsAgreed, setTermsAgreed] = useState();
  const [subTermsAgreed, setSubTermsAgreed] = useState(subscribecheckbox.subscribeIsChecked);
  const [submitTimestamp, setSubmitTimestamp] = useState();
  const [showCheckboxError, setShowCheckboxError] = useState();

  let captcha;
  const captchaContainer = useRef();

  const onLoadRecaptcha = () => captcha && captcha.reset();

  const verifyCallback = (recaptchaToken, grecaptcha) => {
    // Here you will get the final recaptchaToken!!!
    getCaptchFrame().style = "";

    if (recaptchaToken) {
      setCaptchaValidated(true);
    } else {
      grecaptcha.reset();
    }
  };
  const onNameChange = evt => {
    let val = evt.target.value;
    val = val.replace(/^\s*|\s*$/g,"")
    setNameEntered(val);
  };
  const onAppellationChange = value => {
    setAppellationSelected(value);
    setAppellationError(null);
  };
  const onPhoneCodeChange = value => {
    const { onChange } = phoneCode;
    setPhoneCodeError(null);
    onChange && onChange(value);
  };
  const onEmailChange = (evt, isValid) => {
    setEmailEntered(evt.target.value);
  };

  const onEmailBlur = (evt, isValid) => {
    setEmailEntered(evt.target.value);
    const reg = /[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,4}$/;
    if (evt.target.value) {
      let value = evt.target.value;
      let index = -1;
      let other = null;

      if (emailFormat && emailFormat.length > 0) {
        emailFormat.forEach((item) => {
          if (value.indexOf(item) > -1) {
            index = value.indexOf(item);
            other = value.replace(item, "")
          }
        });
      }
      let isValid = false;
      if (index && other) {
        isValid = reg.test(value) && index === other?.length;
      } else {
        isValid = reg.test(value);
      }

      setEmailEnteredIsValid(isValid)
      if(!isValid){
        setEmailError(email.warningMessage);
      }
    }
  };

  const onPhoneChange = (evt, isValid) => {
    setPhoneEntered(evt.target.value);
  };

  const onPhoneBlur = (evt, isValid) => {
    const reg = /^(\d{8}|\d{9}|\d{10}|\d{11})$/;
    setPhoneEntered(evt.target.value);
    if (evt.target.value) {
      setPhoneIsValid(reg.test(evt.target.value));
      if(phoneCodeNode.current.option?.value){
        if(!phoneCodeNumberVaild(evt.target.value, phoneCodeNode.current.option?.code)){
          setPhoneError(phone.warningMessage);
        }
      } else {
        if(!reg.test(evt.target.value)){
          setPhoneError(phone.warningMessage);
        }
      }
    }
  };

  const onCountryChange = value => {
    const { onChange } = country;
    setCountryError(null);
    setDealerError(null);
    onChange && onChange(value);
  };
  const onCityChange = value => {
    const { onChange } = city;
    setCityError(null);
    onChange && onChange(value);
  };
  const onDealerChange = value => {
    const { onChange } = dealer;
    setDealerError(null);
    onChange && onChange(value);
  };
  const onCheckmarkChange = value => {
    setTermsAgreed(value);
    setShowCheckboxError(false);
  };
  const onSubscribeCheckmarkChange = value => {
    setSubTermsAgreed(value);
  };
  const phoneCodeNumberVaild = (value, code) => {
    let reg = /^(\d{8}|\d{9}|\d{10}|\d{11})$/;
    if(code){
      code = code.replace(/\(.*?\)|（.*?\）|[+?]|\s*/g,"");
      if(code == 'SA'){
        reg=/^\d{9}$/
      }
      if(code == 'QA'){
        reg=/^\d{8}$/
      }
      if(code == 'KW'){
        reg=/^\d{8}$/
      }
      if(code == 'OM'){
        reg=/^\d{8}$/
      }
      if(code == 'AE'){
        reg=/^\d{9}$/
      }
      if(code == 'BH'){
        reg=/^\d{8}$/
      }
    }
    let isValid = reg.test(value)
    setPhoneIsValid(isValid)
    return isValid
  }

  const onSubmitFormData = () => {
    setSubmitTimestamp(new Date());
    let valid = true;
    if (!nameEntered) {
      setNameError(name.missingMessage);
      valid = false;
    }
    if (!phoneCodeNode.current.option?.value) {
      setPhoneCodeError(phoneCode.missingMessage);
      valid = false;
    }else{
      let isValid =phoneCodeNumberVaild(phoneEntered , phoneCodeNode.current.option?.code);
      setPhoneError(isValid? null : phone.warningMessage);
      if(!isValid) valid = isValid;
    }
    if (!phoneEntered) {
      setPhoneError(phone.missingMessage);
      valid = false;
    } else {
      let isValid =phoneCodeNumberVaild(phoneEntered , phoneCodeNode.current.option?.code);
      setPhoneError(isValid? null : phone.warningMessage);
      if(!isValid) valid = isValid;
    }
    if (!appellationSelected) {
      setAppellationError(appellation.missingMessage);
      valid = false;
    }
    if (!emailEntered) {
      setEmailError(email.missingMessage);
      valid = false;
    } else if (!emailEnteredIsValid) {
      setEmailError(email.warningMessage);
      valid = false;
    }
    if (!country.selectedOption) {
      setCountryError(country.missingMessage);
      valid = false;
    }
    if (!city.selectedOption) {
      setCityError(city.missingMessage);
      valid = false;
    }
    if (!dealer.selectedOption) {
      setDealerError(dealer.missingMessage);
      valid = false;
    }
    if (!termsAgreed) {
      setShowCheckboxError(true);
      valid = false;
    }
    if (!captchaValidated && hasCaptcha) {
      let captchaValida = getCaptchFrame();
      captchaValida && (captchaValida.style = "padding: 2px 1px 1px 2px; background: red;");
      valid = false;
    }
    if (valid) {
      let data = {
        name: nameEntered,
        appellation: appellationSelected?.code,
        phoneAreaCode: phoneCodeNode?.current?.option?.value.replace(/\(.*?\)|（.*?\）|[+?]|\s*/g,""),
        phoneNumber: phoneEntered,
        email: emailEntered,
        country: country.selectedOption?.code,
        city: city.selectedOption?.code,
        networkCode: dealer?.selectedOption?.code,
        networkName: dealer?.selectedOption?.value,
        ActivityId:'',
        termsAgreed: termsAgreed,
        subTermsAgreed: subscribecheckbox.label !== '' ? subTermsAgreed : false
        // subscribecheckbox.subscribeIsChecked
      };
      onSubmitForm(data);
    }
  };

  const getCaptchFrame = () => {
    return captchaContainer.current.querySelector(".captcha iframe");
  };

  return (
    <form className="test-drive-form">
      {heading && <Heading html={heading.text} type={heading.type} className="title" typographyClass="type-h3" />}
      <div className="test-drive-form-main">
        <div>
          <Input
            {...{
              ...name,
              showError: !!nameError,
              warningMessage: nameError,
              onChange: evt => onNameChange(evt),
              onFocus: () => {
                setNameError(null);
              }
            }}
          />
        </div>
        <div>
          <Dropdown
            className="store"
            {...{
              ...appellation,
              showError: !!appellationError,
              warningMessage: appellationError,
              onFocus: () => {
                setAppellationError(null);
              },
              onChange: value => onAppellationChange(value)
            }}
          />
        </div>
        <div className="colspan">
          <FilterDropdown
            cRef={phoneCodeNode}
            className="phoneCode"
            {...{
              ...phoneCode,
              showError: !!phoneCodeError,
              warningMessage: phoneCodeError,
              oneOfEdit: true,
              tel: true,
              selectCode: '',
              reg:/\(.*?\)|（.*?\）/g,
              maxlength: 10,
              onFocus: () => {
                setPhoneCodeError(null);
              },
              onChange: value => onPhoneCodeChange(value)
            }}
          />
          <Input
            {...{
              type: "tel",
              ...phone,
              showError: !!phoneError,
              warningMessage: phoneError,
              onChange: evt => onPhoneChange(evt),
              onFocus: () => {
                setPhoneError(null);
              },
              onBlur: (evt, isValid) => onPhoneBlur(evt, isValid)
            }}
          />
        </div>
        <div>
          <Input
            {...{
              ...email,
              type: "",
              showError: !!emailError,
              warningMessage: emailError,
              onChange: (evt, isValid) => onEmailChange(evt, isValid),
              onFocus: () => {
                setEmailError(null);
              },
              onBlur: (evt, isValid) => onEmailBlur(evt, isValid)
            }}
          />
        </div>
        <div className="colspan">
          {country && (
            <div className="country">
              <FilterDropdown
                className="store"
                {...{
                  ...country,
                  showError: !!countryError,
                  warningMessage: countryError,
                  onChange: value => onCountryChange(value),
                  onFocus: () => {
                    setCountryError(null);
                  }
                }}
              />
            </div>
          )}
          {city && (
            <div className="city">
              <Dropdown
                className="store"
                {...{
                  ...city,
                  showError: !!cityError,
                  warningMessage: cityError,
                  onChange: value => onCityChange(value),
                  onFocus: () => {
                    setCityError(null);
                  }
                }}
              />
            </div>
          )}
        </div>
        {dealer && (
          <div>
            <Dropdown
              className="store"
              {...{
                ...dealer,
                showError: !!dealerError,
                warningMessage: dealerError,
                nodata: country.selectedOption ? dealer.nodealer : false,
                onChange: value => onDealerChange(value),
                onFocus: () => {
                  setDealerError(null);
                }
              }}
            />
          </div>
        )}
      </div>
      {subscribecheckbox.label !== '' && (
        <Checkbox
          {...{
            ...subscribecheckbox,
            checked: subscribecheckbox.subscribeIsChecked,
            onChange: value => {
              onSubscribeCheckmarkChange(value);
            }
          }}
        />
      )}
      {checkbox && (
        <Checkbox
          {...{
            ...checkbox,
            error: showCheckboxError,
            onChange: value => {
              onCheckmarkChange(value);
            }
          }}
        />
      )}
      

      {hasCaptcha && (
        <div className="captcha" ref={captchaContainer}>
          <ReCaptcha
            ref={el => {
              captcha = el;
            }}
            size="normal"
            data-theme="dark"
            theme="dark"
            render="explicit"
            sitekey={captchaSiteKey}
            onloadCallback={onLoadRecaptcha}
            verifyCallback={captchaToken => {
              verifyCallback(captchaToken, captcha);
            }}
          />
        </div>
      )}

      {errorMessage && hasError && (
        <div
          className="error-message"
          dangerouslySetInnerHTML={{
            __html: errorMessage
          }}
        />
      )}

      {button != null && (
        <PrimaryButton
          {...{
            ...button,
            callback: evt => onSubmitFormData(evt)
          }}
        />
      )}

      <BodyText html={disclaimer} className="disclaimer" />
    </form>
  );
};

TestDriveForm.propTypes = {
  firstname: PropTypes.object,
  lastname: PropTypes.object,
  phoneNumber: PropTypes.shape({
    pattern: PropTypes.string,
    infoMessage: PropTypes.string,
    warningMessage: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    hasError: PropTypes.bool
  }),
  phoneNumberPrefix: PropTypes.object,
  email: PropTypes.shape({
    pattern: PropTypes.string,
    infoMessage: PropTypes.string,
    warningMessage: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    hasError: PropTypes.bool
  }),
  store: PropTypes.shape({
    className: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired
      })
    ),
    stackDirection: PropTypes.oneOf(["horisontal", "vertical"]),
    selectedOption: PropTypes.object,
    placeholder: PropTypes.string,
    onChange: PropTypes.func
  }),
  textarea: PropTypes.shape({
    value: PropTypes.string,
    pattern: PropTypes.string,
    label: PropTypes.string,
    warningMessage: PropTypes.string,
    infoMessage: PropTypes.string,
    showError: PropTypes.bool,
    onFocus: PropTypes.func,
    onChange: PropTypes.func
  }),
  hasCaptcha: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  button: PropTypes.shape({
    callback: PropTypes.func,
    icon: PropTypes.shape({ svg: PropTypes.string }),
    colorScheme: PropTypes.object,
    width: PropTypes.string,
    isDisabled: PropTypes.bool,
    internalLink: PropTypes.any,
    transition: PropTypes.any,
    buttonText: PropTypes.string
  }),
  disclaimer: PropTypes.string,
  onSubmit: PropTypes.func
};

TestDriveForm.defaultProps = {
  onSubmitForm: () => {}
};

export default TestDriveForm;
